function isUndefined (value) {
  return typeof value === 'undefined'
}

module.exports = isUndefined
